import DeprecationHeader from './DeprecationHeader.container';

export default DeprecationHeader;
